export const LUCE_CS_NUMBER = "+65 3138 4827";
